'use client';
import { Button } from '@/components/Button/Button';
import useAnalytics from '@/lib/analytics/useAnalytics';
import { ArrowRightIcon } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

const BottomSection = () => {
  const router = useRouter();

  const { track } = useAnalytics();

  const handleSignupClick = () => {
    router.push('/login');
    track('signup_button_clicked', { location: 'navbar' });
  };
  return (
    <div className="flex flex-col items-start text-start w-full max-w-[1072px] px-6 tracking-tight py-28 max-md:py-24">
      <h2 className="font-interDisplay font-semibold text-[48px] leading-[54px] md:text-[56px] md:leading-[62px] max-w-[820px] mt-5 !tracking-[-0.03em] text-balance">
        Join the millions of academics working 10x faster with Anara
      </h2>
      <p className="text-[22px] leading-[30px] max-w-[750px] mt-4 text-balance">
        Anara helps you understand, organize and write scientific documents with
        AI. Take it for a spin today. No card required.
      </p>
      <div className="flex flex-row items-center justify-center gap-3 mt-4">
        <Button
          size="sm"
          className="tracking-normal text-base leading-4 hover:scale-[1.01] transition-all duration-200 ease-in-out rounded-[10px]"
          onClick={handleSignupClick}
        >
          Get Anara free
        </Button>
        <Link
          href="https://tally.so/r/wbO0j0"
          className="hover:bg-border3 rounded-[10px] h-[38px] px-[16px] inline-flex items-center text-base leading-[18px] tracking-[-0.16px] font-semibold hover:scale-[1.01] transition-all duration-200 ease-in-out"
          target="_blank"
          onClick={() => {
            track('contact_sales_button_clicked', { location: 'navbar' });
          }}
          rel="noopener noreferrer"
        >
          Contact sales
          <ArrowRightIcon className="w-4 h-4 ml-1" strokeWidth={3} />
        </Link>
      </div>
      <Image
        src="/landing/blog.png"
        alt="Anara - Main Section Poster"
        width={1024}
        height={665}
        className="w-full rounded-[17.5px] mt-10 bg-[#F7F7F7]"
      />
    </div>
  );
};

export default BottomSection;
